import type { AppGlobalsType } from '~/global';

let appGlobals: unknown = {};

declare global {
  interface Window {
    __AppGlobals__: AppGlobalsType;
  }
}

export function setAppGlobals(globals: AppGlobalsType) {
  appGlobals = globals;
}

export function getAppGlobals() {
  if (typeof document !== 'undefined') {
    return window.__AppGlobals__;
  }
  return appGlobals as AppGlobalsType;
}
